export let selectAllMessagesCommand = "C9d_Tc";
export default {selectAllMessagesCommand};